module.exports = __webpack_public_path__ + "img/toolbar_grzx.9ba24d05.png";